<template>
    <b-row class="mt-6" v-if="imageGrid && isVisible">
        <b-col class="text-center">
            <h3 class="center-line">FOLLOW US ON INSTAGRAM&nbsp;<span style="position:relative; top: -3px" class="icon-instagram"></span>
                <hr/>
            </h3>
            <b-row>
                <b-col :key="index" :md="12 / imageGrid.size" class="instagram-tile my-2"
                       v-for="(item, index) in imageGrid.imageList">
                    <a href="https://www.instagram.com/accessories.pb/" target="_blank">
                        <img class="card-img-top"
                             :src="imageResource(item, 600)" alt="image"/>
                    </a>
                </b-col>
            </b-row>
        </b-col>
    </b-row>

</template>
<script>

    import ContentAPI from "../../../shared/_api/cms/content";

    export default {
        name: 'instagram',
        data() {
            return {
                imageGrid: undefined,
                isVisible: false
            }
        },
        created() {
            ContentAPI.fetchPageByName("home-image-grid").then(result => {
                if (result.contentDataSet.imageGrid && result.contentDataSet.visibility) {
                    this.imageGrid = result.contentDataSet.imageGrid.value;
                    this.isVisible = result.contentDataSet.visibility.value;
                }
            });
        }
    }
</script>

<style lang="scss" scoped>
    .instagram-tile {
        img {
            object-fit: contain;
            width: 100%;

            &:hover {
                box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);
            }
        }

    }
</style>